import React from 'react';
import Button from './../../components/button/button';

const DownLoadPdf = ({ downloadPDF }) => {
  const tooltipText = "Télécharger le PDF";
  return (
    <div className="buttonContainerDownloadPdf">
      <Button
        customClass={'buttonDownloadPdf'}
        onClick={() => downloadPDF()}
        icon={'picto-download'}
      />
      <span class="toolTipTextOptions">{tooltipText}</span>
    </div>
  )
}

export default DownLoadPdf;